import { createAction } from '@reduxjs/toolkit';

import { VIDEO_ACTIONS } from 'js/src/data/video/video-types';

export const setBrandKitId = createAction<{
    brandKitId: number | null;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(VIDEO_ACTIONS.SET_BRAND_KIT_ID);
